<template>
    <div class="progress">
        <div class="progress_title">
            2. Asesoría pedagógica
        </div>
        <div class="progress_subtitle">
            Asesoría en curso...
        </div>
        <div class="progress_images" v-if="advisory && advisory.teacher_photo">
            <img :src="advisory.teacher_photo">
        </div>
        <div class="progress_images" v-else>
            <img src="@/assets/images/enrollment/profile_default.svg" width="224">
            <!-- <img src="@/assets/images/evaluation/progress.svg"> -->
        </div>
        <div class="progress_fullname" v-if="advisory && advisory.teacher_name">
            {{ advisory.teacher_name }}
        </div>
        <div class="progress_description">
            En unos minutos se pondrá en contacto el asesor pedagógico asignado.
        </div>
        <div class="progress_description">
            Al finalizar su asesoría presione continuar para proceder con su matrícula
        </div>
        <div class="progress_footer">
            <v-btn
                color="primary"
                class="uppercase"
                @click="nextStep"
                :loading="buttonLoading"
                >
                Continuar
            </v-btn>
        </div>
        <v-dialog v-model="adviceInProgress" persistent content-class="schedule_dialog">
            <v-card>
                <v-card-title>
                    <div class="flex-grow-1"></div>
                    <v-btn icon @click="adviceInProgress=false">
                    <v-icon class="iconColor">mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <div class="schedule_dialog_title">
                        Aún no finaliza tu asesoría
                    </div>
                    <div class="schedule_dialog_description mb-md-9 pl-md-8 pr-md-8">
                        Para continuar, debes completar tu asesoría con el docente. El docente te indicará cuando tengas un nivel asignado.                    </div>
                    <div class="schedule_dialog_image">
                        <img src="@/assets/images/evaluation/adviceInProgress.svg" alt="">
                    </div>
                    <div class="schedule_dialog_footer mt-sm-5 mb-sm-7 mt-lg-12">
                        <v-btn
                            color="primary"
                            class="uppercase"
                            @click="adviceInProgress = false"
                            >
                            CERRAR
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from "@/axios-auth"
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            adviceInProgress: false,
            user: null,
            buttonLoading: false
        }
    },
    methods: {
        nextStep(){
            this.buttonLoading = true;
            this.loadPostulation();
        },
        loadPostulation(){
            let obj = {
                user_id: this.user.username,
                postulation_id: this.postulation.id
            }
            axios
                .post(`users/list-postulation/`,
                    obj,
                    { headers: { Authorization: 'Token ' + this.user.token }})
                    .then(response => {

                        let postulationList = response.data.detail;

                        if(postulationList && postulationList.length){
                            if(postulationList[0].advices.length){
                                let currentAdvices = postulationList[0].advices[postulationList[0].advices.length - 1];
                                this.buttonLoading = false;
                                if(currentAdvices.status.id == 2){
                                    this.$emit('completed');
                                    this.$router.push({ path: `/evaluation/schedule/completed` });
                                } else {
                                    this.adviceInProgress = true;
                                }
                            }
                        }

                    })
                    .catch(err => {
                        console.log(err);
                    });
        },
    },
    computed: {
        ...mapGetters({
            language: "language",
            program: "program",
            postulation: "postulation",
            postulationIsNull: "postulationIsNull",
            extraMinutes: "extraMinutes",
            advisory: "advisory"
        }),
    },
    mounted() {
        this.user = this.$store.state.usuario;

        // console.log('this.user');
        // console.log(this.user);
    },
}
</script>
